module.exports = App.Report = DS.Model.extend

  name: DS.attr 'string'
  description: DS.attr 'string'

  group_by: DS.attr 'mixed'
  group_by2: DS.attr 'mixed'
  group_by3: DS.attr 'mixed'
  group_by4: DS.attr 'mixed'

  filters: DS.hasMany 'report-filter', async: true
  reportSchema: DS.belongsTo 'report-schema'


  onReportSchemaChange: (->
    @set('group_by',null)
    @set('group_by2',null)
    @set('group_by3',null)
    @set('group_by4',null)
  ).observes('reportSchema')

  onReportGroupChange: (->
    @set('group_by4',null) unless @get('group_by') && @get('group_by2') && @get('group_by3')
    @set('group_by3',null) unless @get('group_by') && @get('group_by2')
    @set('group_by2',null) unless @get('group_by')
  ).observes('group_by', 'group_by2', 'group_by3', 'group_by4')
